import IMAGES from '../assets/images';
import CustomImage from './CustomImage';

// type ComingSoonCardProps = {
//   title: string;
//   subtitle?: string;
//   description?: string;
//   supportText?: string;
// };

const ComingSoon = () => {
  return (
    <div className="w-full mx-auto rounded-2xl border flex items-center justify-center bg-white dark:border-theme-gray-700 dark:bg-theme-slate-800 h-[calc(100vh_-_140px)]">
      <CustomImage width={500} height={500} src={IMAGES.comingSoon} />
    </div>
  );
};

export default ComingSoon;
